var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5356 6L20 9.46439L9.46439 20L6 16.5356L7.38881 15.1468L8.4266 16.1846L9.12863 15.4826L8.09084 14.4448L8.77762 13.758L10.5022 15.4826L11.2042 14.7805L9.47965 13.056L10.1664 12.3692L11.2042 13.407L11.9062 12.7049L10.8685 11.6671L11.5552 10.9804L13.3012 12.7202L13.6339 12.3692C13.817 12.1769 13.9666 12.0121 13.9666 12.0029C13.9666 11.9937 13.582 11.603 12.2573 10.2783L12.944 9.59156L13.9818 10.6293L14.6839 9.92731L13.6461 8.88952L14.3328 8.20275L16.0788 9.94257L16.4115 9.59156C16.5946 9.39926 16.7442 9.23443 16.7442 9.22528C16.7442 9.21612 16.3596 8.82542 15.0349 7.50071L16.5356 6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.585f60cacc066ec83d76a2252ec5774d.svg";
export { ForwardRef as ReactComponent };